export default {
    setBudgetPrice(state, price) {
        state.payload.PriceFrom = price?.min;
        state.payload.PriceTo = price?.min;
        state.price.min = price?.min;
        state.price.max = price?.max;
    },

    updateBudgetPrice(state, priceTo) {
        state.payload.PriceTo = priceTo;
    },
    setDiamondShape(state, Shape) {
        state.payload.Shape = Shape;
    },
    setPrioritySize(state,{Sort, Color, Clarity }){
        state.payload.Sort = Sort;
        state.payload.Color = Color;
        state.payload.Clarity = Clarity;
    },
    setPriorityQuality(state, { Color, Clarity,Sort }) {
        state.payload.Color = Color;
        state.payload.Clarity = Clarity;
        state.payload.Sort = Sort;
    },
    setPriorityBalance(state, { Color, Clarity, Sort }) {
        state.payload.Color = Color;
        state.payload.Clarity = Clarity;
        state.payload.Sort = Sort;
    },
    setUpdatedResult(state,result) {
        state.result = result;
    },

    setNextPage(state){
        state.currentPage++
    },
    setPrevPage(state){
        state.currentPage--
    }
}
